<template>
  <section class="page">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-10 offset-sm-1">
          <div class="container mb-2 py-3">
            <h5 class="title">主催者登録継続申請</h5>
          </div>
        </div>
        <!-- {{ $store.state.oauth }} -->
        <div class="col-12 col-sm-10 offset-sm-1" v-if="chk_app_already_finish">
          <div class="container py-3">
            <div class="row">
              <div class="col">
                <p class="box box--center mb-24">
                  申請は完了しています。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="[100, 200].includes(parseInt((application_obj || {}).application_check_type))">
          <div class="container py-3">
            <div class="row">
              <div class="col">
                <p class="box box--center mb-24">
                  申請中です
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="col-12 col-sm-10 offset-sm-1">
          <div class="container py-3">
            <p class="box box--center mb-24" v-if="[600].includes(parseInt((application_obj || {}).application_check_type))">
              {{ application_obj.comment }}
            </p>
            <p class="box box--center mb-24" v-else>
              {{ message }}
            </p>
          </div>
          <div class="container mb-3">
            <div class="row mb-2">
              <h5 class="title02">申請年度</h5>
            </div>
          </div>
          <div class="container mb-4">
            <div class="row">
              <div class="col-10 col-sm-5 offset-sm-1 mb-2" v-for="year in get_term_year_list" :key="year">
                <div class="d-grid" v-if="chk_term_year_event_year(year)">
                  <button class="button03">
                    {{ year }}年はすでに申請されています。
                  </button>
                </div>
                <div class="d-grid" v-else>
                  <button :class="get_selected_year_class(year)" @click="toggleSelectedYear(year)">
                    {{ year }}年<span v-if="get_term_year_list.length == 1">を申請する</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="container mb-3">
            <div class="row mb-2">
              <h5 class="title02">登録情報</h5>
            </div>
          </div>
          <div class="container mb-3">
            <div class="page__inputGroup">
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">主催者コード</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.owner_no }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">主催者名称</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.name_1 }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">カナ</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.yomi_1 }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <div class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">代表者</span>
                  <div class="d-flex w-100">
                    <div class="w-50">
                      <p class="page__inputGroupContent">
                        <span class="col-2">姓</span>
                        <span class="showData page__inputGroupInput">{{ form_obj.name_2 }}</span>
                      </p>
                    </div>
                    <div class="w-50">
                      <p class="page__inputGroupContent">
                        <span class="col-2">名</span>
                        <span class="showData page__inputGroupInput">{{ form_obj.name_3 }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page__inputGroupCol">
                <div class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">カナ</span>
                  <div class="d-flex w-100">
                    <div class="w-50">
                      <p class="page__inputGroupContent">
                        <span class="col-2">セイ</span>
                        <span class="showData page__inputGroupInput">{{ form_obj.yomi_2 }}</span>
                      </p>
                    </div>
                    <div class="w-50">
                      <p class="page__inputGroupContent">
                        <span class="col-2">メイ</span>
                        <span class="showData page__inputGroupInput">{{ form_obj.yomi_3 }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page__inputGroupCol">
                <div class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">〒・都道府県</span>
                  <div class="page__inputWrap">
                    <p class="page__inputGroupContent">
                      <span class="col-2">〒</span>
                      <span class="showData page__inputGroupInput">{{ form_obj.postal_cd }}</span>
                      <button
                        v-if="!change_mode"
                        type="button"
                        class="button"
                        @click="get_address()"
                      >
                        検索
                      </button>
                    </p>
                  </div>
                  <div class="page__inputWrap">
                    <p class="page__inputGroupContent">
                      <span class="col-2">都道府県</span>
                      <span v-if="change_mode" class="showData page__inputGroupInput">{{ get_pref_label(form_obj.pref_cd) }}</span>
                      <bs-select
                        v-else
                        :options="pref_list"
                        :nullOption="false"
                        v-model="form_obj.pref_cd"
                        :readonly="input_readonly"
                      ></bs-select> 
                    </p>
                  </div>
                </div>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">市区町村・番地</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.address_1 }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">建物名・室号</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.address_2 }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">電話番号1</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.tel_1 }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <p class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">電話番号2</span>
                  <span class="showData page__inputGroupInput">{{ form_obj.tel_2 }}</span>
                </p>
              </div>
              <div class="page__inputGroupCol">
                <div class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">主催カテゴリ</span>
                  <div class="col-10 offset-1 offset-lg-0 col-lg-10">
                    <div class="row">
                      <div
                        class="col-6 col-md-4 col-lg-4 mb-2"
                        v-for="event in event_list"
                        :key="event"
                      >
                        <div class="d-grid">
                          <span :class="event_class(event.id)" disabled="disabled">
                            {{ event.label }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="page__inputGroupCol">
                <div class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">主催者資格</span>
                  <div class="col-10 offset-1 offset-lg-0 col-lg-10">
                    <div class="row">
                      {{ form_obj.race_owner_type_cd_label }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="page__inputGroupCol" v-if="form_obj.race_owner_type_cd==8">
                <div class="page__inputGroupInner"><span class="page__inputLabel page__inputGroupLabel">クラブ情報</span>
                  <div class="page__inputWrap">
                    <p class="page__inputGroupContent">
                      <span class="col-2">クラブNo</span>
                      <span class="showData page__inputGroupInput">{{ form_obj.club_no }}</span>
                    </p>
                  </div>
                  <div class="page__inputWrap">
                    <p class="page__inputGroupContent">
                      <span class="col-2">クラブ名</span>
                      <span class="showData page__inputGroupInput">{{ form_obj.club_label }}</span>
                    </p>
                  </div>
                </div>
                <!-- <div>5名以上必要(公認クラブ)の注意文>>{{ form_obj.m_relation_cnt }}</div> -->
              </div>
            </div>
          </div>
          <div class="container mt-5">
            <div class="row">
              <div class="col-3 col-lg-4 text-start">
                <button
                  class="button03"
                  @click="back"
                  v-if="change_mode"
                >
                  戻る
                </button>
                <button
                  class="button03"
                  @click="back"
                  v-else
                >
                  戻る
                </button>
              </div>
              <div class="col-6 col-lg-4" v-if="(form_obj.race_owner_type_cd!=8 || (form_obj.race_owner_type_cd==8 && parseInt(form_obj.m_relation_cnt) >= 5))">
                <div class="d-grid">
                  <button
                    v-if="change_mode"
                    type="button"
                    @click="go_app"
                    class="button04"
                  >
                    申請する
                  </button>
                  <button
                    v-else
                    type="button"
                    @click="confirm_chk"
                    class="button04"
                  >
                    確認する
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
  .input-group > .form-control-plaintext {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    padding: 0.375rem;
    border-bottom: solid 1px #999;
  }
  .form-control-plaintext {
    border-bottom: solid 1px #999;
  }
</style>

<script>
  import { mapState } from 'vuex'
  // import BsPageTitle from '../../molecules/BsPageTitle.vue'
  // import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
  // import BsSelect from '../../atoms/BsSelect.vue'
  // import BsCheckBox from '../../atoms/BsCheckBox.vue'
  // import '../../assets/bootstrap/css/sc.css';
  import BsSelect from '../../atoms/BsSelect.vue'
  import config from '../../../const'

  export default {
    name: 'UserDataView',
    data: function () {
      return {
        targetid: this.$store.state.oauth.userId,
        btnLabel: '',
        data_obj: {},
        form_obj: {},
        change_login_id: '',
        confirm_login_id: '',
        change_mode: true,
        message:
          '申請年度を確認し、下の申請ボタンを押して申請を行って下さい。',
        pref_obj: [],
        request_type_cd_obj: [],
        application_obj: {},
        application_type_obj: [],
        application_check_type_obj: [],
        shipping_address_obj: [],
        event_cd_obj: [],
        event_relation_obj: [],
        license_event_cd_obj: [],
        license_event_relation_obj: [],
        m_relation_obj: [],
        selected_years: []
      }
    },
    components: {
      BsSelect,
      //   BsMsgAlert,
      // BsCheckBox,
    },
    methods: {
      async toggleSelectedYear(year){
        if(this.chk_selected_year(year)){
          this.selected_years = this.selected_years.filter(tmp => tmp != year)
        }else{
          this.selected_years.push(year)
        }
      },
      async get_address() {
        const postal_cd = this.form_obj.postal_cd
        await this.basicGets_O(
          'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + postal_cd
        )
          .then((res) => {
            if (
              typeof res === 'object' &&
              typeof res.status === 'number' &&
              res.status == 200 &&
              typeof res.data === 'object' &&
              typeof res.data.results === 'object' &&
              typeof res.data.results[0] === 'object'
            ) {
              this.form_obj.pref_cd =
                parseInt(res.data.results[0].prefcode) < 10
                  ? '0' + res.data.results[0].prefcode
                  : res.data.results[0].prefcode
              this.form_obj.address_1 =
                res.data.results[0].address2 + res.data.results[0].address3
              this.form_obj.address_2 = ''
            } else {
              alert('住所データがありません')
            }
          })
          .catch((error) => {
            console.log(error)
            alert('住所データがありません.')
          })
          .finally(() => {
            this.$forceUpdate()
          })
      },
      async selectedFile(e, type_cd) {
        e.preventDefault()
        const files = [...e.target.files]
        // let ups = [];
        files.forEach(async (file) => {
          const form = new FormData()
          form.append('file', file)
          await this.basicPosts_R(
            config.BASE_API_URL + '/upload/owner_assets',
            form
          )
            .then((res) => {
              console.log(res)
              if (res && res.status == 200) {
                const asset_tmp = {
                  id: 0,
                  stat: 1,
                  o_id: this.$store.state.oauth.userId,
                  type: 0,
                  path: '',
                }
                const tmps =
                  typeof this.form_obj.owner_assets === 'object'
                    ? [...this.form_obj.owner_assets]
                    : []
                const asset = tmps.find((tmp) => tmp.type == type_cd)
                  ? tmps.find((tmp) => tmp.type == type_cd)
                  : asset_tmp
                asset.type = type_cd
                asset.path = res.data.body.file_path
                  ? res.data.body.file_path
                  : ''

                if (tmps.find((tmp) => tmp.id == asset.id)) {
                  const fIndex = tmps.findIndex((tmp) => tmp.id == asset.id)
                  tmps[fIndex] = asset
                  this.form_obj.owner_assets = tmps
                } else {
                  this.form_obj.owner_assets = [asset].concat(tmps)
                }
              }
            })
            .catch((error) => {
              console.log(error)
            })
            .finally(() => {
              document.getElementById('file_up_input_' + type_cd).value = ''
              this.$forceUpdate()
            })
        })
      },
      async clickUpFileBtn() {
        document.getElementById('file_up_input_100').click()
      },
      async loadConfigObj(param) {
        const params = {}
        await this.basicPosts_S(
          config.BASE_API_URL + '/config/' + param,
          params
        )
          .then(async (response) => {
            console.log('loadConfigObj response', response)
            this[param + '_obj'] =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this[param + '_obj'] = []
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async loadPrefList() {
        const params = {}
        params['stat'] = [1]
        await this.basicPosts_S(
          config.BASE_API_URL + '/area_pref/lists',
          params
        )
          .then(async (response) => {
            console.log('loadPrefList response', response)
            this.pref_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.pref_obj = []
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async loadShippingObj() {
        const params = {}
        params['stat'] = [1]
        params['o_id'] = this.$store.state.oauth.userId
        params['pagegroup'] = 'mfj_owner_shipping_address.id'
        await this.basicPosts_S(
          config.BASE_API_URL + '/owner_shipping/lists',
          params
        )
          .then(async (response) => {
            console.log('loadShippingObj', response)
            this.shipping_address_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.shipping_address_obj = []
          })
          .finally(async () => {
            // await this.setOwnerObj();
            this.$forceUpdate()
          })
      },
      async loadOwnerObj() {
        const params = {}
        params['stat'] = [1]
        params['id'] = this.$store.state.oauth.userId
        params['pagegroup'] = 'mfj_owner_data.id'
        await this.basicPosts_S(config.BASE_API_URL + '/owner/lists', params)
          .then(async (response) => {
            console.log('loadOwnerObj', response)
            this.data_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
          })
          .catch(async (err) => {
            console.log(err)
            this.data_obj = []
          })
          .finally(async () => {
            await this.setOwnerObj()
            this.$forceUpdate()
          })
      },
      async loadEventCdObj() {
        const params = {}
        params['stat'] = [1]
        await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
          .then(async (response) => {
            console.log('loadEventCdObj', response)
            this.event_cd_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.event_cd_obj = []
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async loadEventRelationObj() {
        const params = {}
        params['stat'] = [1]
        params['event_years'] = this.get_term_year_list_plus_pre
        params['o_id'] = this.$store.state.oauth.userId
        console.log('loadEventRelationObj params', params)
        await this.basicPosts_S(
          config.BASE_API_URL + '/owner_event_relation/lists',
          params
        )
          .then(async (response) => {
            console.log('loadEventRelationObj', response)
            this.event_relation_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.event_relation_obj = []
          })
          .finally(async () => {
            // await this.setOwnerObj();
            this.$forceUpdate()
          })
      },
      async loadLicenseEventCdObj() {
        const params = {}
        params['stat'] = [1]
        await this.basicPosts_S(
          config.BASE_API_URL + '/license_event_cd/lists',
          params
        )
          .then(async (response) => {
            console.log('loadLicenseEventCdObj', response)
            this.license_event_cd_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.license_event_cd_obj = []
          })
          .finally(async () => {
            this.$forceUpdate()
          })
      },
      async loadLicenseEventRelationObj() {
        const params = {}
        params['stat'] = [1]
        params['o_id'] = this.$store.state.oauth.userId
        console.log('loadLicenseEventRelationObj params', params)
        await this.basicPosts_S(
          config.BASE_API_URL + '/owner_license_event_relation/lists',
          params
        )
          .then(async (response) => {
            console.log('loadLicenseEventRelationObj', response)
            this.license_event_relation_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.license_event_relation_obj = []
          })
          .finally(async () => {
            // await this.setOwnerObj();
            this.$forceUpdate()
          })
      },
      async loadApplicationObj() {
        const params = {}
        params['stat'] = [1]
        params['o_id'] = this.$store.state.oauth.userId
        params['application_type'] = 11300;
        params['not_application_check_types'] = [500, 900]
        await this.basicPosts_S(
          config.BASE_API_URL + '/owner_application/lists',
          params
        )
          .then(async (response) => {
            console.log('loadApplicationObj', response)
            this.application_obj = (response.data && response.data.body && response.data.body[0])? response.data.body[0]: {};
          })
          .catch(async (err) => {
            console.log(err)
            this.application_obj = {}
          })
          .finally(async () => {
            await this.setOwnerObj()
            this.$forceUpdate()
          })
      },
      async setOwnerObj() {
        if (this.data_obj.tel_1 == '--') {
            this.data_obj.tel_1 = '';
        }
        if (this.data_obj.tel_2 == '--') {
            this.data_obj.tel_2 = '';
        }

        if(this.data_obj){
          const tmpAuth = {
            token: this.data_obj?.token,
            userId: this.data_obj?.id,
            label: this.data_obj?.name_1,
            type: 'owner',
            owner_no: this.data_obj?.owner_no,
            entry_system: this.data_obj?.entry_system,
            event_years: this.data_obj?.event_years,
            term_years: this.data_obj?.term_years
          }
          console.log('tmpAuth', tmpAuth)
          this.$store.dispatch('setOAuth', tmpAuth)
        }
        
        
        // postal_cdがundefinedでないことを確認
        if (this.data_obj.postal_cd && this.data_obj.postal_cd.indexOf('-') < 0 && this.data_obj.postal_cd.length > 3) {
            const start_code = this.data_obj.postal_cd.substr(0, 3);
            const end_code = this.data_obj.postal_cd.substr(3);
            this.data_obj.postal_cd = start_code + '-' + end_code;
        }

        this.form_obj = {
            owner_no: this.data_obj.owner_no,
            name_1: this.data_obj.name_1,
            name_2: this.data_obj.name_2,
            name_3: this.data_obj.name_3,
            yomi_1: this.data_obj.yomi_1,
            yomi_2: this.data_obj.yomi_2,
            yomi_3: this.data_obj.yomi_3,
            postal_cd: this.data_obj.postal_cd,
            pref_cd: this.data_obj.pref_cd,
            address_1: this.data_obj.address_1,
            address_2: this.data_obj.address_2,
            tel_1: this.data_obj.tel_1,
            tel_2: this.data_obj.tel_2,
            owner_assets: this.data_obj.owner_assets,
            website_url_1: this.data_obj.website_url_1,
            license_event_relation: this.data_obj.license_event_relation,
            race_owner_type_cd_label: this.data_obj.race_owner_type_cd_label,
            race_owner_type_cd: this.data_obj.race_owner_type_cd,
            club_no: this.data_obj.club_no,
            club_label: this.data_obj.club_label,
            m_relation_cnt: this.data_obj.m_relation_cnt,
            // mail_1: this.data_obj.mail_1,
            // mail_2: this.data_obj.mail_2,
            // mail_flg: this.data_obj.mail_flg,
        };
      },
      async confirm_chk() {
        // if(
        //     this.change_login_id == '' || this.confirm_login_id == ''
        // ){
        //     alert('変更するログインIDを入力して下さい');
        //     return true;
        // }
        // else if(
        //     this.change_login_id != '' && this.confirm_login_id != ''
        //     && this.change_login_id != this.confirm_login_id
        // ){
        //     alert('入力されたログインIDが一致しません');
        //     return true;

        // }
        this.change_mode = true
      },
      async go_app(){
        if(!Array.isArray(this.selected_years) || (Array.isArray(this.selected_years) && this.selected_years.length <= 0)){
          alert('申請する年度を選択して下さい')
          return
        }
        const confirm_msg = '年度更新の申請を行います。よろしいですか？'
        if(
          !window.confirm(confirm_msg)
        ){
          return
        }

        const items = []
        // if(Array.isArray(this.get_term_year_list) && this.get_term_year_list.length > 0){
        //   this.get_term_year_list.forEach((year, index) => {
        if(Array.isArray(this.selected_years) && this.selected_years.length > 0){
          this.selected_years.forEach((year, index) => {
            if(!this.chk_term_year_event_year(year)){
              if(index == 0){
                items.push({
                  application_id: (this.application_obj?.id)? this.application_obj.id: 0,
                  application_key: 'mfj_outdb_data@last_sports_year',
                  application_value: year
                })
              }else{
                items.push({
                  application_id: (this.application_obj?.id)? this.application_obj.id: 0,
                  application_key: 'mfj_outdb_data@next_sports_year',
                  application_value: year
                })
              }
            }
          })
        }
        
        const params = {
          application_check_type: (this.application_obj||{}).application_check_type == 600? 120: 100,
          application_type: 11300,
          o_id: this.targetid,
          items: typeof items === 'object' && items.length > 0 ? items : false
        }

        const post_url = (this.application_obj||{}).id
          ? config.BASE_API_URL + '/owner_application/edit/' + (this.application_obj||{}).id
          : config.BASE_API_URL + '/owner_application/add'
        await this.basicPosts_I(
            post_url,
            params
          )
          .then(async (response) => {
            console.log('update', response)
          })
          .catch(async (err) => {
            console.log(err)
          })
          .finally(async () => {
            await this.loadOwnerObj()
            await this.loadApplicationObj();
            alert('申請しました')
            this.$forceUpdate()
          })
      },
      // async update() {
      //   console.log('component methods', this.data_obj)

      //   const params = {
      //     name_1: this.form_obj.name_1,
      //     name_2: this.form_obj.name_2,
      //     yomi_1: this.form_obj.yomi_1,
      //     yomi_2: this.form_obj.yomi_2,
      //     birth_date: this.form_obj.birth_date,
      //     profile: [],
      //     owner_assets: this.form_obj.owner_assets,
      //   }
      //   let profiles
      //   let upd_profile = {
      //     id: 0,
      //     o_id: this.$store.state.oauth.userId,
      //     postal_cd: '',
      //     pref_cd: '',
      //     address_1: '',
      //     address_2: '',
      //     tel_1: '',
      //     tel_2: '',
      //   }
      //   if (
      //     typeof this.data_obj === 'object' &&
      //     typeof this.data_obj.profile === 'object' &&
      //     Object.keys(this.data_obj.profile).length > 0
      //   ) {
      //     profiles = [...this.data_obj.profile]
      //     upd_profile = profiles[0]
      //   } else {
      //     profiles.push({ ...upd_profile })
      //   }
      //   if (this.form_obj.postal_cd) {
      //     upd_profile.postal_cd = this.form_obj.postal_cd
      //   }
      //   if (this.form_obj.pref_cd) {
      //     upd_profile.pref_cd = this.form_obj.pref_cd
      //   }
      //   if (this.form_obj.address_1) {
      //     upd_profile.address_1 = this.form_obj.address_1
      //   }
      //   if (this.form_obj.address_2) {
      //     upd_profile.address_2 = this.form_obj.address_2
      //   }
      //   if (this.form_obj.tel_1) {
      //     upd_profile.tel_1 = this.form_obj.tel_1
      //   }
      //   if (this.form_obj.tel_2) {
      //     upd_profile.tel_2 = this.form_obj.tel_2
      //   }

      //   profiles[0] = upd_profile

      //   params.profile = profiles

      //   await this.basicPosts_I(
      //     config.BASE_API_URL + '/owner/edit/' + this.$store.state.oauth.userId,
      //     params
      //   )
      //     .then(async (response) => {
      //       console.log('update', response)
      //     })
      //     .catch(async (err) => {
      //       console.log(err)
      //       this.data_obj = []
      //     })
      //     .finally(async () => {
      //       await this.loadOwnerObj()
      //       this.message = '更新しました'
      //       this.$forceUpdate()
      //     })
      // },

      async loadMRelationObj() {
        const params = {}
        params['stat'] = [1]
        params['o_id'] = this.$store.state.oauth.userId
        console.log('loadMRelationObj params', params)
        await this.basicPosts_S(
          config.BASE_API_URL + '/owner_m_relation/lists',
          params
        )
          .then(async (response) => {
            console.log('loadMRelationObj', response)
            this.m_relation_obj =
              response.data && response.data.body ? response.data.body : []
          })
          .catch(async (err) => {
            console.log(err)
            this.m_relation_obj = []
          })
          .finally(async () => {
            // await this.setOwnerObj();
            this.$forceUpdate()
          })
      },
      back_input() {
        this.change_mode = false
      },
      back() {
        this.$router.push({ path: '/owner/mypage' })
      },
    },
    computed: {
      chk_selected_year: function(){
        const selected = this.selected_years
        return function(year){
          if(
            selected.includes((year))
          ){
            return true
          }
          else{
            return false
          }
        }
      },
      get_selected_year_class: function(){
        const chk = this.chk_selected_year
        return function(year){
          if(chk(year)){
            return 'button04'
          }else{
            return 'button03'
          }
        }
      },
      ...mapState({}),
      get_term_year_list: function(){
        return this.$store.state.oauth.term_years
      },
      get_term_year_list_plus_pre: function(){
        const tmps = [...this.get_term_year_list]
        const minYear = Math.min(...tmps);
        if(minYear){
          tmps.push(minYear - 1)
        }else{
          const now = new Date()
          tmps.push(now.getFullYear())
        }
        return tmps
      },
      chk_app_already_finish: function(){
        if(
          Array.isArray(this.$store.state.oauth.event_years) && 
          this.$store.state.oauth.event_years.length > 0 &&
          Array.isArray(this.get_term_year_list) && 
          this.get_term_year_list.length > 0 && 
          this.$store.state.oauth.event_years.length == this.get_term_year_list.length
        ){
          return true
        }
        return false
      },
      chk_term_year_event_year: function(){
        const auth_event_years = this.$store.state.oauth.event_years
        return function(year){
          return (Array.isArray(auth_event_years) && auth_event_years.find(year_obj => parseInt(year_obj.event_year) === parseInt(year)))? true: false
        }
      },

      m_relation_list: function () {
        const m_relation_obj = this.m_relation_obj
        return m_relation_obj.sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
        // return this.m_relation_obj;
      },
      // get_assets: function () {
      //   const form_obj = this.form_obj
      //   return function (type_cd, sort_key) {
      //     if (
      //       typeof form_obj === 'object' &&
      //       typeof form_obj.owner_assets === 'object' &&
      //       form_obj.owner_assets.find((asset) => asset.type == type_cd) !==
      //         false &&
      //       typeof form_obj.owner_assets.filter(
      //         (asset) => asset.type == type_cd
      //       ) === 'object' &&
      //       typeof form_obj.owner_assets.filter(
      //         (asset) => asset.type == type_cd
      //       )[sort_key] === 'object'
      //     ) {
      //       // console.log('get_assets', form_obj.owner_assets.filter(asset => asset.type == type_cd));
      //       return form_obj.owner_assets.filter(
      //         (asset) => asset.type == type_cd
      //       )[sort_key]
      //     }
      //     return {}
      //   }
      // },
      get_pref_label: function () {
        const pref_list = this.pref_list
        return function (key) {
          if (typeof pref_list.find((pref) => pref.key == key) === 'object') {
            return pref_list.find((pref) => pref.key == key).label
          }
          return key
        }
      },
      get_request_cd_label: function () {
        const lists = this.request_type_list
        return function (key) {
          if (typeof lists.find((list) => list.key == key) === 'object') {
            return lists.find((list) => list.key == key).label
          }
          return key
        }
      },
      event_class: function () {
        const relation = this.event_relation_obj
        return function (event_id) {
          if (relation.find((obj) => obj.event_id == event_id)) {
            return 'text-center py-2 bg-warning rounded-2'
          } else {
            return 'text-center py-2 bg-light rounded-2 border border-secondary'
          }
        }
      },
      event_list: function () {
        const lists = [...this.event_cd_obj]
        return lists.sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
      },
      license_event_class: function () {
        const relation = this.license_event_relation_obj
        return function (license_event_id) {
          if (
            relation.find((obj) => obj.license_event_id == license_event_id)
          ) {
            return 'text-center py-2 bg-warning rounded-2'
          } else {
            return 'text-center py-2 bg-light rounded-2 border border-secondary'
          }
        }
      },
      license_event_list: function () {
        const lists = [...this.license_event_cd_obj]
        return lists.sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
      },
      request_type_list: function () {
        return this.request_type_cd_obj
      },
      pref_list: function () {
        const lists = [...this.pref_obj]
        return lists.sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
      },
      application_type_list: function () {
        return this.application_type_obj
      },
      application_check_type_list: function () {
        return this.application_check_type_obj
      },
      
      application_btn_class: function () {
        return function (check_type) {
          let base = 'btn btn-sm '
          base +=
            check_type == 100
              ? 'btn-light btn-outline-secondary'
              : check_type == 200
              ? 'btn-light btn-outline-secondary'
              : check_type == 500
              ? 'btn-success'
              : check_type == 600
              ? 'btn-warning'
              : check_type == 900
              ? 'btn-danger'
              : check_type == 990
              ? 'btn-danger'
              : 'btn-light btn-outline-secondary'
          return base
        }
      },
      shipping_address_list: function () {
        return this.shipping_address_obj.filter((shipping, index) => {
          if (typeof shipping === 'object' && index == 0) {
            return true
          }
        })
      },
      get_owner_data: function () {
        return {
          name_1: this.data_obj.name_1,
          name_2: this.data_obj.name_2,
          line_name_1: this.data_obj.line_name_1,
          line_name_2: this.data_obj.line_name_2,
          name_3: this.data_obj.name_3,
          yomi_1: this.data_obj.yomi_1,
          yomi_2: this.data_obj.yomi_2,
          yomi_3: this.data_obj.yomi_3,
          birth_date: this.data_obj.birth_date,
          postal_cd: this.data_obj.birth_date,
          pref_cd: this.data_obj.birth_date,
          address_1: this.data_obj.address_1,
          address_2: this.data_obj.address_2,
          tel_1: this.data_obj.tel_1,
          tel_2: this.data_obj.tel_2,
          mail_1: this.data_obj.mail_1,
          mail_2: this.data_obj.mail_2,
          mail_flg: this.data_obj.mail_flg,
        }
      },
      input_class: function () {
        if (this.change_mode) {
          return 'form-control-plaintext'
        } else {
          return 'form-control'
        }
      },
      input_readonly: function () {
        if (this.change_mode) {
          return true
        } else {
          return false
        }
      },
    },
    async created() {
      await this.loadConfigObj('request_type_cd')
      await this.loadConfigObj('application_type')
      await this.loadConfigObj('application_check_type')
      await this.loadPrefList()
      // await this.loadShippingObj()
      await this.loadOwnerObj()
      await this.loadApplicationObj()
      await this.setOwnerObj()
      await this.loadLicenseEventCdObj()
      // await this.loadLicenseEventRelationObj()
      await this.loadEventCdObj()
      await this.loadEventRelationObj()

      this.selected_years = [...this.get_term_year_list]
      // await this.loadMRelationObj()
    },
    mounted: function () {
      // console.log('tags_list', this.tags_list);
    },
    props: {},
  }
</script>
